export enum MessageType {
  Note = 'NOTE'
  // TODO: Add other types here.
}
